import { captureRemixErrorBoundaryError } from "@sentry/remix";
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteError,
} from "@remix-run/react";
import { LinksFunction } from "@remix-run/node";
import styles from "~/styles/global.css?url";

import { useEffect } from "react";
import MyLayout from "~/layouts/Layout";
import { screenBrand } from "~/module/brand/brand";
import { reportUnresolvedBrand } from "~/module/brand/report";
import { brandThemeCss } from "~/module/brand/theme";

import Modal from "react-modal";
import { AuthProvider } from "./context/AuthContext";

export const links: LinksFunction = () => {
  // favicon は画面のテナントから解決する。SPA モードのため、ここはビルド時に確定する
  // （実行時に差し替える方式では既定テナントのアイコンが一瞬見える＝D5）。
  const brand = screenBrand();
  return [
    { rel: "stylesheet", href: styles },
    brand.favicon
      ? { rel: "icon", href: brand.favicon }
      : {
          rel: "icon",
          href: "/favicon.png",
          type: "image/png",
        },
  ];
};

export function Layout({ children }: { children: React.ReactNode }) {
  Modal.setAppElement("#modal");
  // 配色は画面のテナントから解決する。favicon と同じ理由でビルド時に確定させ、
  // 既定の配色が一瞬見えることを避ける（D5）。
  const themeCss = brandThemeCss();
  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
        {themeCss ? <style dangerouslySetInnerHTML={{ __html: themeCss }} /> : null}
      </head>
      <body>
        <AuthProvider>{children}</AuthProvider>
        <ScrollRestoration />
        <Scripts />
        <div id="modal"></div>
      </body>
    </html>
  );
}
export function HydrateFallback() {
  return <MyLayout>loading...</MyLayout>;
}
export const ErrorBoundary = () => {
  const error = useRouteError();
  console.error(error);
  captureRemixErrorBoundaryError(error);
  return <MyLayout>something went wrong...</MyLayout>;
};

export default function App() {
  // ブランドを解決できなかった場合に検知できるようにする（画面は出したうえで記録する。D13）。
  useEffect(() => {
    reportUnresolvedBrand();
  }, []);
  return <Outlet />;
}
